import { render, staticRenderFns } from "./AsRegister.vue?vue&type=template&id=6e18441b&scoped=true"
import script from "./AsRegister.vue?vue&type=script&lang=js"
export * from "./AsRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e18441b",
  null
  
)

export default component.exports